import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-premium-template-upgrade-account',
    templateUrl: './premium-template-upgrade-account.component.html',
    standalone: false
})
export class PremiumTemplateUpgradeAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
